import React from 'react';
import PropTypes from 'prop-types';
import Panel from '../Panel';
import TabMenu from '../TabMenu';

export default function RetailerAdminHeader(props) {
  const { retailerId } = props;

  return (
    <Panel fix>
      <TabMenu title="Sellers" to={`/retailers/${retailerId}/admin/brands`} />
      <TabMenu title="Accounts" to={`/retailers/${retailerId}/admin/account`} />
      <TabMenu title="Users" to={`/retailers/${retailerId}/admin/users`} />
    </Panel>
  );
}

RetailerAdminHeader.propTypes = {
  retailerId: PropTypes.number.isRequired,
};
